__turbopack_context__.v({
  "container": "whatYouWillDoSection-module-scss-module__34C7hq__container",
  "heading": "whatYouWillDoSection-module-scss-module__34C7hq__heading",
  "list": "whatYouWillDoSection-module-scss-module__34C7hq__list",
  "mainContent": "whatYouWillDoSection-module-scss-module__34C7hq__mainContent",
  "separator": "whatYouWillDoSection-module-scss-module__34C7hq__separator",
});
